// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2hHSt","requiredAsterisk":"Info_requiredAsterisk__3h7DO"};